import { useTranslation } from 'react-i18next';
import { UserAlliance } from '../../types/alliance';
import ProfileAvatar from '../common/ProfileAvatar';
import { getFreelancerSubtitle } from '../../utils/freelancerUtils';
import { Bell } from 'lucide-react';
import { Button } from '../common/Button';
import { useState } from 'react';
import { LoadingSpinner } from '../LoadingSpinner';
import { AllianceRespondModal } from './AllianceRespondModal';
import { Link } from 'react-router-dom';
interface Props {
  pendingRequests: UserAlliance[];
  loading: boolean;
}

const AllianceRequests = ({ pendingRequests, loading }: Props) => {
  const { t } = useTranslation('alliances');

  const [selectedAlliance, setSelectedAlliance] = useState<UserAlliance | null>(null);

  return (
    <div className="mb-6 md:mb-8">
      <h2 className="text-sm font-semibold text-secondary mb-4">{t('newRequests')}</h2>
      {pendingRequests.length === 0 && !loading && (
        <div className="text-sm text-gray-500 mb-4">{t('noNewRequests')}</div>
      )}
      {pendingRequests.map(req => (
        <div
          key={req.alliance_id}
          className="bg-[#E1E9F0] rounded-3xl flex flex-col p-2 mb-4 shadow relative md:p-6 md:flex-row md:round-2xl md:bg-white md:items-center md:justify-between"
        >
          <div className="flex flex-row justify-between gap-4 mb-8 ml-1 md:mb-0">
            <div className="flex flex-row items-center gap-4">
              <ProfileAvatar
                profile_id={req.user.id}
                first_name={req.user.first_name}
                avatar_url={req.user.avatar_url}
                className="bg-primary text-white mt-3"
              />
              <div className="flex flex-col mt-4">
                <Link to={`/freelancers/${req.user.id}`} className="font-bold text-secondary">
                  {req.user.first_name}
                </Link>
                <div className="text-sm text-secondary">{getFreelancerSubtitle(req.user, t)}</div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-4 w-full px-6 md:gap-8 md:w-auto md:flex-row-reverse md:mt-10">
            <Button
              className="w-full md:w-auto md:px-10"
              onClick={() => {
                setSelectedAlliance(req);
              }}
            >
              {t('showRequest', { ns: 'alliances' })}
            </Button>
          </div>
          <div className="absolute top-2 right-2 w-10 h-10 rounded-full flex items-center justify-center">
            <Bell className="w-5 h-5 text-secondary" />
            <span className="absolute -top-0.5 right-0.5 bg-primary text-white text-xs rounded-full px-2 py-0.5">
              !
            </span>
          </div>
        </div>
      ))}
      {loading && (
        <div className="flex justify-center items-center h-10">
          <LoadingSpinner />
        </div>
      )}

      {selectedAlliance && (
        <AllianceRespondModal
          alliance={selectedAlliance}
          onClose={() => setSelectedAlliance(null)}
        />
      )}
    </div>
  );
};

export default AllianceRequests;
